<template>
  <v-container class="pa-2" fluid fill-height>
    <v-layout row wrap>
      <v-card width="100%">
        <v-toolbar flat color="white">
          <v-text-field style="width:100%" clearable flat solo :value="currentFilters.query" @input="onQueryInput" prepend-icon="search" label="Быстрый поиск" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn icon flat @click="openFilter">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
          <v-btn icon flat @click="openFilter">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />
        <v-data-table :headers="headers" :items="items" :loading="loading" :total-items="total" :disable-initial-sort="true" :rows-per-page-items="rowsPerPageItems" :rows-per-page-text="rowsPerPageText" flat item-key="id" :pagination="currentPagination" @update:pagination="updatePagination">
          <v-progress-linear slot="progress" color="blue" height="3" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center pa-2">
              <v-avatar round color="teal" size="40">
                <img v-if="props.item.image" :src="props.item.image|avatar" @error="props.item.image=''" />
              </v-avatar>
            </td>
            <td class="text-xs-left pa-2">{{ props.item.last_name+' '+props.item.first_name+' '+props.item.mid_name }}</td>
            <td class="text-xs-left pa-2">{{ props.item.email }}</td>
            <td class="text-xs-left pa-2">{{ props.item.phone }}</td>
            <td class="text-xs-center pa-2">
              <v-icon small color="red" v-if="props.item.is_free">mdi-circle</v-icon>
            </td>
            <td class="text-xs-center pa-2">
              <v-icon small color="red" v-if="props.item.premium">star</v-icon>
            </td>
            <td class="text-xs-center pa-2">
              <v-icon small color="red" v-if="props.item.is_admin">mdi-circle</v-icon>
            </td>
            <td class="text-xs-left pa-2">{{ props.item.created_at }}</td>
            <td class="text-xs-center pa-2">
              <v-icon v-if="props.item.description" small>info</v-icon>
            </td>
            <td class="text-xs-center pa-2">
              <v-tooltip top>
                <v-icon class="mr-3" @click="showCard(props.item)" slot="activator">mdi-account-card-details</v-icon>
                <span>Открыть карточку пользователя</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon class @click="showPosts(props.item)" slot="activator">mdi-domain</v-icon>
                <span>Посты и созданные группы</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog" persistent :max-width="dialogWidth" scrollable>
        <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveDialog"></component>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from 'lodash'
import UserForm from '../Forms/UserForm'
import PostsForm from '../Forms/PostsForm'
import FilterForm from '../Forms/UserFilterForm'
import { list } from '@/apps/accounts/api'
import listMixin from '@/mixins/list'

export default {
  name: 'UserList',
  mixins: [listMixin],

  data() {
    return {
      search: '',
      formProps: {},
      dialog: false,
      dialogWidth: 600,
      currentComponent: null,
      headers: [{ text: 'Фото', align: 'left', sortable: false, value: false, width: 60 }, { text: 'ФИО', align: 'left', value: 'first_name' }, { text: 'Email', align: 'left', value: 'email' }, { text: 'Телефон', align: 'left', value: 'phone' }, { text: 'Бесплатный доступ', align: 'center', value: 'is_free', sortable: true }, { text: 'Премиум', align: 'center', value: 'premium', sortable: true }, { text: 'Админ', align: 'center', value: 'is_admin', sortable: true }, { text: 'Дата регистрации', align: 'left', value: 'created_at' }, { text: 'Описание', align: 'center', value: 'description' }, { text: 'Операции', align: 'center', sortable: false, value: false, width: 60 }],
      filter: {}
    }
  },
  filters: {
    avatar(token) {
      // @todo  Вынести и сделать параметрическим
      return `https://dantser.com/disk/d/${token}`
    }
  },
  methods: {
    loadItems() {
      let { descending = null, sortBy = null, page = 1, rowsPerPage = 10 } = this.currentPagination
      let requestData = {
        pagination: {
          page: page,
          page_size: rowsPerPage
        },
        search: {}
      }

      if (sortBy !== null) {
        let order = {
          field: sortBy
        }
        order.type = descending === true ? 'desc' : 'asc'
        requestData.order = order
      }

      // Query search
      if (this.currentFilters.query) {
        requestData.search.query = this.currentFilters.query
      }

      this.loading = true
      const p = list(requestData).then(data => {
        this.items = data.items
        this.total = data.total
      })
      p.finally(_ => {
        this.loading = false
      })
      return p
    },
    onQueryInput: debounce(function(value) {
      let filters = this.initFilters(this.currentFilters)
      filters.query = value
      this.updateFilters(filters)
    }, 500),

    showCard(item) {
      this.$dmsShowDialog({
        component: UserForm,
        props: {
          formData: item
        },
        dialogProps: {
          scrollable: true
        },
        listeners: {
          save: () => {
            this.refresh()
          }
        }
      })
    },

    showPosts(item) {
      this.$dmsShowDialog({
        component: PostsForm,
        props: {
          account: item
        },
        dialogProps: {
          scrollable: true,
          maxWidth: 640
        },
        loading: true,
        listeners: {
          save: () => {
            // this.refresh()
          }
        }
      })
      // this.dialogWidth = 1000
      // this.formProps = {
      //   data: item
      // }
      // this.currentComponent = PostsForm
      // this.dialog = true
    },

    openFilter() {
      this.dialogWidth = 600
      this.formProps = {
        data: this.filter
      }
      this.currentComponent = FilterForm
      this.dialog = true
    },

    saveDialog(eventData) {
      switch (eventData.type) {
        case 'filter':
          this.filter = eventData.data
          break
      }
      this.dialog = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/apps/accounts/components/List/index.vue